// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__8rnku","warning":"Badge_warning__5MJwA","error":"Badge_error__vSmAL","success":"Badge_success__ueEV1"};